import React, { useEffect, useState } from 'react';
import Slider from 'react-slick';
import { Box, Typography, Button } from '@mui/material';
import { motion } from 'framer-motion';
import bannerService from '../../services/bannerServices';

const Banner = () => {
  const [bannerData, setBannerData] = useState([]);

  useEffect(() => {
    const loadData = async () => {
      const res = await bannerService.fetchAll();
      // console.log(res);
      setBannerData(res.data);
    }
    loadData();
  }, []);

  const settings = {
    dots: true,
    infinite: true,
    speed: 1000,
    autoplay: true,
    autoplaySpeed: 4000,
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    arrows: false,
  };

  const textAnimation = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.8 } },
  };

  return (
    <Slider {...settings}>
      {bannerData && bannerData.map((banner, index) => (
        <Box
          key={banner.id}
          className="banner-bg"
          sx={{
            background: `url(${banner.image}) no-repeat center/cover`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
            px: 4,
          }}
        >
          <Box
            sx={{
              maxWidth: '50%',
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
              borderRadius: '8px',
              padding: '35px',
            }}
            className="banner-content"
          >
            <motion.div
              initial="hidden"
              animate="visible"
              variants={textAnimation}
            >
              <Typography
               className='bannerTITLE'
                variant="h3"
                fontWeight='100'
                color={banner.title_color || 'white'}
                sx={{
                  mb: 2,
                  fontSize: {
                    xs: '1.5rem',
                    sm: '2rem',
                    md: '2.25rem',
                  },
                }}
              >
                {banner.title}
              </Typography>
              <Typography 
                 className='bannerSUBTITLE'
                 variant="h6" 
                 color={banner.description_color || 'white'} sx={{ mb: 4 }}>
                {banner.description}
              </Typography>
              {banner.url && (
                <Button variant="contained" color="primary" href={banner.url} target="_blank">
                  Read More
                </Button>
              )}
            </motion.div>
          </Box>
        </Box>
      ))}
    </Slider>
  );
};

export default Banner;
